 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"0e3eb78e83870bd8043dc80a35c7677187fb4e75","4":"component---src-pages-404-js","5":"component---src-pages-account-management-email-notification-settings-mdx","6":"component---src-pages-account-management-login-mdx","7":"component---src-pages-account-management-organization-mdx","8":"component---src-pages-account-management-profile-settings-mdx","9":"component---src-pages-account-management-register-mdx","10":"component---src-pages-account-management-security-settings-mdx","11":"component---src-pages-account-management-user-logs-mdx","12":"component---src-pages-account-management-user-notification-mdx","13":"component---src-pages-calculator-bond-pricing-calculator-mdx","14":"component---src-pages-calculator-bond-yield-calculator-mdx","15":"component---src-pages-chat-chat-deal-making-mdx","16":"component---src-pages-chat-chat-function-mdx","17":"component---src-pages-dashboard-dashboard-information-mdx","18":"component---src-pages-dashboard-dashboard-introduction-mdx","19":"component---src-pages-dashboard-dashboard-order-mdx","20":"component---src-pages-events-event-calendar-mdx","21":"component---src-pages-index-tsx","22":"component---src-pages-market-primary-market-info-mdx","23":"component---src-pages-market-primary-market-order-mdx","24":"component---src-pages-market-secondary-market-info-mdx","25":"component---src-pages-market-secondary-market-order-mdx","26":"component---src-pages-my-deals-deal-history-mdx","27":"component---src-pages-my-deals-ongoing-deals-mdx","28":"component---src-pages-my-deals-settlements-mdx","29":"component---src-pages-news-browse-news-mdx","30":"component---src-pages-news-post-news-mdx","31":"component---src-pages-securities-securities-info-mdx","32":"component---src-pages-security-applications-new-security-application-mdx","33":"component---src-pages-security-disclosures-new-disclosure-mdx","34":"component---src-pages-security-disclosures-update-disclosure-mdx","35":"component---src-templates-article-tsx","36":"component---src-templates-category-tsx"}[chunkId]||chunkId) + "-" + {"0":"064c2995b1d3888222c6","4":"1fa8506293bf8006906d","5":"0e5a05217a42fc48e774","6":"9f924ae9d5abfc692f47","7":"3a1d6813a7480744487f","8":"4693cb4bd2e82919a4da","9":"84f7bd11b08b76fbdb5b","10":"092b08962ba6c53eba09","11":"9be4016356187e17a9cf","12":"ab582521922b596943ca","13":"ef09320af092b2f91e97","14":"042a60652d1ddb2e42fc","15":"9fd45be4efb99eef2e56","16":"040eae37b0e0bca8ef1d","17":"3980a059e2cb677539fb","18":"167fccd6ba84077e2a60","19":"afd26b022c72e4813e86","20":"b156936534a3b3d410e5","21":"c75b647d3bce2c50dedc","22":"ef1692a289120c11be6c","23":"d22955360f9c214b305b","24":"b3ab6c911a8e55a445ca","25":"30f2e6634fdbc47bd4f5","26":"9b24e82b282c8be55991","27":"295f474a5ddfd1034c90","28":"deebc73b9c949929fa82","29":"faeb157dc05664dea1e2","30":"24416e2b08437ebffc45","31":"4037a1a1cbef0a088d58","32":"6f74f58beab6bb0f0b0a","33":"aa2032b9c0f43b289b1c","34":"dfe316f98f09a9e78f33","35":"05bfcd795fd23dece2f8","36":"e68831e6c81b04e23173"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
